import { Network } from '@capacitor/network'
import { useEffect, useState } from 'react'

export const useNetworkStatus = () => {
  const [networkStatus, setNetworkStatus] = useState<boolean | undefined>(undefined)

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const status = await Network.getStatus()
        setNetworkStatus(status.connected)
      } catch {
        setNetworkStatus(undefined)
      }
    }

    checkStatus()
  }, [])

  useEffect(() => {
    const listenerHandle = Network.addListener('networkStatusChange', status => {
      setNetworkStatus(status.connected)
    })

    return () => {
      listenerHandle.then(handle => handle.remove())
    }
  }, [])

  // Network status is undefined upon load
  if (networkStatus) {
    return 'online'
  }

  return networkStatus === undefined ? undefined : 'offline'
}
